import React from 'react';
import styled from 'styled-components';

import { BREAKPOINTS } from 'config/constants';
import { CountrySelectField } from 'components/Form/Inputs/Select/variants/CountrySelect.Formik';
import Flex from 'components/Flex';
import TextInput from 'components/Form/Inputs/Text/Text.Formik';
import { WizardContext } from 'components/Wizard/types';

const InputWrapper = styled(Flex)`
  flex-direction: column;
  > div {
    flex: 1;
  }

  @media screen and (min-width: ${BREAKPOINTS.SM}px) {
    flex-direction: row;

    > div {
      margin-left: 0.5rem;
      margin-right: 0.5rem;

      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
`;

interface ArtistMembersFormProps {
  disabled: boolean;
  context: WizardContext;
}

export const ArtistMembersForm: React.FC<ArtistMembersFormProps> = ({
  disabled,
  context
}) => {
  const commonInputProps = {
    disabled,
    showRequiredFields: context === 'promo-pool'
  };

  return (
    <div data-testid={ARTIST_MEMBERS_FORM_TEST_IDS.CONTAINER}>
      <InputWrapper>
        <TextInput label="Email" name="pro_email" {...commonInputProps} />

        <Flex>
          <TextInput
            label="City"
            name="address"
            inputStyle={{ minWidth: 0 }}
            style={{ marginRight: '1rem' }}
            {...commonInputProps}
          />
          <div style={{ flex: 0 }}>
            <CountrySelectField
              name="country"
              compact
              showFlag
              abbreviateRequired
              {...commonInputProps}
            />
          </div>
        </Flex>
      </InputWrapper>

      <InputWrapper>
        <TextInput label="First Name" name="first_name" {...commonInputProps} />
        <TextInput label="Last Name" name="last_name" {...commonInputProps} />
      </InputWrapper>
    </div>
  );
};

export const ARTIST_MEMBERS_FORM_TEST_IDS = {
  CONTAINER: 'ArtistMembersForm'
};

export default ArtistMembersForm;
